import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../../App";
import NotificationModal from "../../containers/shared/NotificationModal";
import NormalButton from "../shared/NormalButton";

export default function NotificationTable({ notification,currentPage=false,pageSize=0 }) {

    const navigate = useNavigate();

    const { NotificationCategoriesOptions } = useContext(UserContext);

    const [selectedNotification, setSelectedNotification] = useState();
    const [showNotificationDetails, setShowNotificationDetails] = useState(false);


    const handleClickNotificationRow = (Notification) => {
        
    }

    const handleClickShowPopup = (Notification) => {
        // setSelectedNotification(Notification);
        // setShowNotificationDetails(true);
    }

    const handleCloseModal = () => {
        setShowNotificationDetails(false);
    }

    const notificationStatus = (notification) => {
        if(notification.quantity - notification?.issuedQuantity <= notification?.reorderPoint) {
            return <span className="text-danger">إعادة طلب</span>;
        }
        if(notification?.issuedQuantity / notification?.quantity > 0.75) {
            return <span className="text-warning">وشك على النفاذ</span>;
        } else {
            return <span className="text-success">متوفر</span>;
        }
    } 

    const handleShowNotificationDetails = (notification) => {
        setSelectedNotification(notification);
        setShowNotificationDetails(true);
    }

    const handleClickEditNotification = () => {
        navigate(`/ar/notification/edit/${selectedNotification?._id}`);
    }

    const getUserRoleName = (role) => {
        switch(role) {
            case 'ADMINISTRATOR':
                return 'المدراء';
            case 'EMPLOYEE':
                return 'الموظفين';
            case 'BENEFICIARY':
                return 'المستفيدين';
            default:
                return '';
        }
    }


    return (
        <>
        <div className="">
            <table className="w-full mt-[30px] max-w-[100%]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">عنوان التنبيه</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 w-[50%]">رسالة التنبيه</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الفئة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">عدد المنبهين</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]">التفاصيل</th>
                </tr>
                </thead>
                <tbody>
                {notification.map((Notification, index) => {;
                    return (
                    <tr key={`notification-${index}`} className={`${index !== notification?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === notification?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickNotificationRow(Notification)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickNotificationRow(Notification)}>{Notification?.title}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer relative`} onClick={()=>handleClickNotificationRow(Notification)}><div className="absolute leading-[62px] top-0 left-[15px] right-[15px] bottom-0 h-full text-ellipsis overflow-hidden text-nowrap">{Notification?.body}</div></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickNotificationRow(Notification)}>{getUserRoleName(Notification?.roles[0])}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickNotificationRow(Notification)}>{Notification?.users?.length === 0 ? 'كل الفئة مستهدفة' : Notification?.users?.length}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === notification?.length-1 && 'rounded-bl-[8px]'}`} onClick={()=>handleClickShowPopup(Notification)}><div className="text-blue underline font-[600] text-[14px] cursor-pointer select-none" onClick={()=>handleShowNotificationDetails(Notification)}>تفاصيل التنبيه</div></td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          { showNotificationDetails && <NotificationModal handleCloseModal={handleCloseModal}>
            <div className="">
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] px-[16px]">
                    <span className="text-[12px] text-grey-900 font-[600]">عنوان التنبيه:</span> {selectedNotification?.title}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">رسالة التنبية:</span> {selectedNotification?.body}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الفئة المستهدفة:</span> {getUserRoleName(selectedNotification?.roles[0])}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">عدد المنبهين:</span> {selectedNotification?.users?.length === 0 ? 'كل الفئة مستهدفة' : selectedNotification?.users?.length}
                </div>
                {selectedNotification?.users?.length > 0 && <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">اسماء المنبهين:</span> {selectedNotification?.users?.map(user=>user?.name).join(', ')}
                </div>}
                <div className="text-end p-[16px] !pt-[0]">
                    <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[15px]" onClick={handleCloseModal}>إلغاء</div>
                </div>
            </div>
        </NotificationModal> }

        </>
    )
}

